var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCalendarIcon2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 2.15945L16.2 1.27308C16.2 0.741264 15.84 0.386719 15.3 0.386719C14.76 0.386719 14.4 0.741264 14.4 1.27308L14.4 2.15945L9.9 2.15945L9.9 1.27308C9.9 0.741264 9.54 0.386719 9 0.386719C8.46 0.386719 8.1 0.741264 8.1 1.27308L8.1 2.15945L3.6 2.15945L3.6 1.27308C3.6 0.741264 3.24 0.386719 2.7 0.386719C2.16 0.386719 1.8 0.741264 1.8 1.27308L1.8 2.15945C0.81 2.15945 0 2.95717 0 3.93217L0 16.3413C0 17.3163 0.81 18.114 1.8 18.114L16.2 18.114C17.19 18.114 18 17.3163 18 16.3413L18 3.93217C18 2.86854 17.19 2.15945 16.2 2.15945ZM16.2 15.4549C16.2 15.9867 15.84 16.3413 15.3 16.3413L2.7 16.3413C2.16 16.3413 1.8 15.9867 1.8 15.4549L1.8 6.59126C1.8 6.05945 2.16 5.7049 2.7 5.7049L15.3 5.7049C15.84 5.7049 16.2 6.05945 16.2 6.59126L16.2 15.4549Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10011 13.9455L4.86011 10.7546L6.12011 9.5137L8.10011 11.3751L11.8801 7.65234L13.1401 8.89325L8.10011 13.9455Z",
    fill: "#222222"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendarIcon2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar-icon2.dcc8988a.svg";
export { ForwardRef as ReactComponent };